export const friendConstant = {
    GET_MY_FRIEND_REQUEST: 'GET_MY_FRIEND_REQUEST',
    GET_MY_FRIEND_SUCCESS: 'GET_MY_FRIEND_SUCCESS',
    GET_MY_FRIEND_FAILURE: 'GET_MY_FRIEND_FAILURE',
    
    ADD_FRIEND_REQUEST: 'ADD_FRIEND_REQUEST',
    ADD_FRIEND_SUCCESS: 'ADD_FRIEND_SUCCESS',
    ADD_FRIEND_FAILURE: 'ADD_FRIEND_FAILURE',
}